import useSWR from 'swr';

// this immitates our existing Nuxt experiment behavior where we check enroll evry 60 seconds
const experimentRefreshInterval = 60;

export default function useExperiment(
  experiment: string,
  skipEnroll: boolean = false,
) {
  const { data, error } = useSWR(
    skipEnroll ? null : `/api/sumotest/enroll/?experiment=${experiment}`,
    { refreshInterval: 1000 * experimentRefreshInterval },
  );
  const { variant } = data || {};

  return {
    variant,
    isLoading: !error && !data,
    isError: error,
  };
}
